import SubSections from '~/constants/vdp/subSections';
import InfoSash from './InfoSash';

type OwnProps = { maxIncentivesAmount?: number };

export default function IncentivesBadge({ maxIncentivesAmount }: OwnProps) {
  if (!maxIncentivesAmount) return null;

  const badgeText = `Up to $${maxIncentivesAmount.toLocaleString()} in available incentives`;

  return (
    <InfoSash
      adobeId="loyalty-incentives-badge"
      analyticsDescription="incentives"
      bgColor="bg-background-success-subtle"
      leadingText={badgeText}
      section={SubSections.Incentives}
      testId="loyalty-incentives-badge"
    />
  );
}
